import { useSeoMeta } from '@unhead/react';
import { POSProvider } from '@/contexts/POSContext';
import { POSShell } from '@/components/pos/POSShell';

const Index = () => {
  useSeoMeta({
    title: 'BCHPAY.Cash',
    description: 'Accept Bitcoin Cash payments instantly. Simple, fast merchant POS terminal.',
  });

  return (
    <POSProvider>
      <POSShell />
    </POSProvider>
  );
};

export default Index;
